import React, { useState } from "react";
import useStyles from "../styles";
import config from "../../../config";

// components
import PageTitle from "../../../components/PageTitle/PageTitle";
import InputComponent from "../../partner/components/inputComponent";
import InputDecimal from "../../partner/components/inputDecimal";
import { CircularProgress, Switch } from "@material-ui/core";
import Modal from "../../modals/Modal";

export default function AddOtherConcept() {
    const expressions = {
        usuario: /^[a-zA-Z0-9_-]{4,16}$/, // Letras, numeros, guion y guion_bajo
        nombre: /^[a-zA-ZÀ-ÿ\s]{1,40}$/, // Letras y espacios, pueden llevar acentos.
        password: /^.{4,12}$/, // 4 a 12 digitos.
        email: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
        numbers: /^[0-9]*$/, // 7 a 14 numeros.
        texto: /^[a-zA-Z0-9 ]{1,500}$/, // Letras
        textNumberAndSymbols: /^[a-zA-ZÀ-ÿ\sS&%'#+-@"!¡¿?()0-9._]+$/i
    }

    const classes = useStyles();

    const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl);
    const [name, setName] = useState({ text: '', valid: null });
    const [cost, setCost] = useState({ text: '', valid: null });
    const [percent, setPercent] = useState(false);

    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const closeModalLogin = e => {
        setShowModal(false);
    }

    const handleChange = event => {
        setPercent(event.target.checked);
    };

    const onSubmit = async e => {
        e.preventDefault();
        setIsLoading(true);

        if (name.valid === 'true' && cost.valid === 'true') {
            const newOtherConcept = {
                name: name.text, byPercent: percent ? 1 : 0, cost: cost.text
            };

            const response = await fetch(baseUrl + "createOtherConcept", {
                method: 'POST',
                headers: {
                    'Accept': 'application/json', 'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem("token")
                },
                body: JSON.stringify(newOtherConcept)
            });
            const json = await response.json();
            if (json.message == "Ok") {
                setName({ text: '', valid: null });
                setPercent(false);
                setCost({ text: '', valid: null });
            } else {
                if (json.message == "Access is denied") {
                    setShowModal(true);
                }
            }

            setIsLoading(false);
        } else {
            setIsLoading(false);
        }
    }

    return (
        <div>
            {showModal ? (
                <Modal
                    isOpen={showModal}
                    closeModal={closeModalLogin}
                />
            ) : (
                <></>
            )}
            <PageTitle title="Configuración" />

            <div className={classes.divAddPage} >
                <div className={classes.divTitle}>
                    <label className={classes.titleStyle}>Agregar otro concepto</label>
                </div>

                <div className={classes.divColumn} >
                    <InputComponent
                        text={name}
                        setPartnerCode={setName}
                        type="text"
                        label="Nombre"
                        name="name"
                        regularExpression={expressions.textNumberAndSymbols}
                        placeholder="Nombre"
                    />

                    <div>
                        <label className={classes.label} >¿Es porcentaje?</label>
                        <div className={classes.divSwitch}>
                            <p style={{ marginRight: "8px", fontSize: "16px", }}>No</p>
                            <Switch
                                checked={percent}
                                onChange={handleChange}
                                inputProps={{ "aria-label": "controlled" }}
                            />
                            <p style={{ marginLeft: "8px", fontSize: "16px", }}>Si</p>
                        </div>
                    </div>

                    <div style={{ display: "flex", alignItems: "end" }}>
                        {percent ? (
                            <></>
                        ) : (
                            <text style={{ marginBottom: "8px" }}>$</text>
                        )}
                        <InputDecimal
                            text={cost}
                            setPartnerCode={setCost}
                            type="text"
                            label="Costo"
                            name="price"
                            placeholder="0.00"
                        />
                        {!percent ? (
                            <></>
                        ) : (
                            <text style={{ marginBottom: "8px" }}>%</text>
                        )}
                    </div>
                </div>

                <div className={classes.divButton}>
                    {isLoading ? (
                        <div className={classes.loginLoader} >
                            <CircularProgress size={26} />
                        </div>

                    ) : (
                        <button
                            className={name.valid === 'true' && cost.valid === 'true' ?
                                classes.enableButton : classes.disableButton}
                            onClick={onSubmit}
                        >Agregar</button>
                    )}
                </div>
            </div>
        </div>
    );
}
